import React, { useMemo, useState } from 'react'
import { rankWith, and, scopeEndsWith } from '@jsonforms/core'
import { JsonForms } from '@jsonforms/react'
import { materialRenderers, materialCells } from '@jsonforms/material-renderers'
import { withJsonFormsControlProps } from '@jsonforms/react'

import ComponentWrapper from 'designer/component/display/layout/control/ComponentWrapper'
import DragContainerWrapper from 'designer/component/system/layout/control/DragContainerWrapper'
import CustomPanelGroup from 'designer/component/container/panel/PanelGroup'
import {
  createPanelGroupSystemRenderer,
  createPanelGroupDisplayRenderer,
} from 'designer/component/control/renderer'

const panelGroupTester = rankWith(
  3,
  and(scopeEndsWith('panelGroup'), (schema) => !schema.subGroup)
)

const subPanelGroupTester = rankWith(
  3,
  and(scopeEndsWith('panelGroup'), (schema) => schema.subGroup)
)

export const PanelGroupSystem = (props) => {
  let { uischema } = props
  const defaultActiveKey =
    uischema.elements.length > 0 ? uischema.elements[0].key : ''
  const [activeTab, setActiveTab] = useState({
    key: defaultActiveKey,
    index: 0,
  })
  const renderers = useMemo(
    () => createPanelGroupSystemRenderer(uischema.elements, activeTab.key),
    [JSON.stringify(uischema.elements), activeTab.key]
  )
  const displayRenderers = useMemo(
    () => createPanelGroupDisplayRenderer(uischema.elements, activeTab.key),
    [uischema.key, activeTab.key]
  )

  return (
    <DragContainerWrapper {...props}>
      <CustomPanelGroup
        {...props}
        renderers={renderers}
        displayRenderers={displayRenderers}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        isSystem={true}
      />
    </DragContainerWrapper>
  )
}

export const SubPanelGroupSystem = (props) => {
  let { uischema } = props
  const defaultActiveKey =
    uischema.elements.length > 0 ? uischema.elements[0].key : ''
  const [activeTab, setActiveTab] = useState({
    key: defaultActiveKey,
    index: 0,
  })
  const renderers = useMemo(
    () => createPanelGroupSystemRenderer(uischema.elements, activeTab.key),
    [JSON.stringify(uischema.elements), activeTab.key]
  )

  const displayRenderers = useMemo(
    () => createPanelGroupDisplayRenderer(uischema.elements, activeTab.key),
    [uischema.key, activeTab.key]
  )

  return (
    <DragContainerWrapper {...props}>
      <CustomPanelGroup
        {...props}
        renderers={renderers}
        displayRenderers={displayRenderers}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        isSystem={true}
      />
    </DragContainerWrapper>
  )
}

export const PanelGroupDisplay = (props) => {
  let { uischema } = props
  const defaultActiveKey =
    uischema.elements.length > 0 ? uischema.elements[0].key : ''
  const [activeTab, setActiveTab] = useState({
    key: defaultActiveKey,
    index: 0,
  })
  const renderers = useMemo(
    () => createPanelGroupDisplayRenderer(uischema.elements, activeTab.key),
    [uischema.key, activeTab.key]
  )

  return (
    <ComponentWrapper {...props}>
      <CustomPanelGroup
        {...props}
        renderers={renderers}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
    </ComponentWrapper>
  )
}

export const SubPanelGroupDisplay = (props) => {
  let { uischema } = props
  const defaultActiveKey =
    uischema.elements.length > 0 ? uischema.elements[0].key : ''
  const [activeTab, setActiveTab] = useState({
    key: defaultActiveKey,
    index: 0,
  })
  const renderers = useMemo(
    () => createPanelGroupDisplayRenderer(uischema.elements, activeTab.key),
    [uischema.key, activeTab.key]
  )

  return (
    <ComponentWrapper {...props}>
      <CustomPanelGroup
        {...props}
        renderers={renderers}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
    </ComponentWrapper>
  )
}

export const panelGroupSystem = {
  tester: panelGroupTester,
  renderer: withJsonFormsControlProps(PanelGroupSystem),
}

export const subPanelGroupSystem = {
  tester: subPanelGroupTester,
  renderer: withJsonFormsControlProps(SubPanelGroupSystem),
}

export const panelGroupDisplay = {
  tester: panelGroupTester,
  renderer: withJsonFormsControlProps(PanelGroupDisplay),
}

export const subPanelGroupDisplay = {
  tester: subPanelGroupTester,
  renderer: withJsonFormsControlProps(SubPanelGroupDisplay),
}
